import React from 'react'
import project from '../../project'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import axios from 'axios';
import Select from 'react-select'
// import BreachCodes from './BreachCodes'

import "../assets/styles/home.scss"

const apiURL_storage = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/AFLdraftTracker2023/prod/AFLdraftTracker2023.json'

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstInteraction: false,
      data: undefined,
      filteredData: [],
      posOptions: [
        { value: 'All', label: 'All' },
        { value: 'Adelaide Crows', label: 'Adelaide Crows' },
        { value: 'Brisbane Lions', label: 'Brisbane Lions' },
        { value: 'Carlton Blues', label: 'Carlton Blues' },
        { value: 'Collingwood Magpies', label: 'Collingwood Magpies' },
        { value: 'Essendon Bombers', label: 'Essendon Bombers' },
        { value: 'Fremantle Dockers', label: 'Fremantle Dockers' },
        { value: 'Geelong Cats', label: 'Geelong Cats' },
        { value: 'Gold Coast Suns', label: 'Gold Coast Suns' },
        { value: 'GWS Giants', label: 'GWS Giants' },
        { value: 'Hawthorn Hawks', label: 'Hawthorn Hawks' },
        { value: 'Melbourne Demons', label: 'Melbourne Demons' },
        { value: 'North Melbourne', label: 'North Melbourne' },
        { value: 'Port Adelaide', label: 'Port Adelaide' },
        { value: 'Richmond Tigers', label: 'Richmond Tigers' },
        { value: 'St Kilda Saints', label: 'St Kilda Saints' },
        { value: 'Sydney Swans', label: 'Sydney Swans' },
        { value: 'West Coast Eagles', label: 'West Coast Eagles' },
        { value: 'Western Bulldogs', label: 'Western Bulldogs' }
      ],
      // selectedStates: [],
      selectedPos: { label: "All", value: "All" },
      // selectedSort: 'lastname',
      // selectedSortDirection: 'asc',
      iconList: ['flag-adelaide','flag-brisbane','flag-carlton','flag-collingwood','flag-essendon','flag-fremantle','flag-geelong','flag-goldcoast','flag-gws','flag-hawthorn','flag-melbourne','flag-northmelbourne','flag-portadelaide','flag-richmond','flag-stkilda','flag-sydney','flag-westcoast','flag-westernbulldogs'],
      activeCard: null,
      breach: null
    }

    // this.checkIcon = this.checkIcon.bind(this)
    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    this.loadData()
  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  checkIcon (iconName) {
    const icon = this.state.iconList.includes(iconName) ? iconName : false
    return icon
  }

  loadData () {
    
    axios.get(apiURL_storage)
    .then((response) => {
      // console.log('response', response)
      let titlesRemoved = response.data.values
      titlesRemoved.shift()

      const cleanData = titlesRemoved.filter( card => card.length )
      const dataPaired = cleanData.map((player) => {
        // console.log('player', player)
        const newPlayer = {}

        newPlayer.pick = player[0] ? player[0].trim() : ''
        newPlayer.club = player[1] ? player[1].trim() : ''
        newPlayer.icon = player[2] ? this.checkIcon( player[2].trim() ) : ''
        newPlayer.name = player[3] ? player[3].trim() : ''
        newPlayer.profile = player[4] ? player[4].trim() : ''

        return newPlayer
      });

      // console.log('dataPaired', dataPaired);

      // const dataSorted = this.sortByKey(dataPaired, this.state.selectedSort, this.state.selectedSortDirection)

      this.setState({
        data: dataPaired
      }, function () {
        this.filterList ()
      });

    })
    .catch((err) => {
      console.log('err', err)
    })

  }

  

  changePos (e) {
    const pos = e
    // console.log('pos', pos)
    this.setState({
      selectedPos: pos
    }, () => {
      this.filterList()
    })
  }

  filterList () {
    // console.log('time to filter')
    // console.log(this.state.selectedStates)
    // console.log(this.state.selectedPos)
    // console.log(' this.state.data',  this.state.data)

    const filteredList = this.state.data.filter((record) => {
      // IF ALL states and ALL positions
      if ( this.state.selectedPos['value'] == 'All' ) {
        // console.log('IF ALL states and ALL positions');
        return record //record.stat == this.state.selectedPos['value']
      } 
      // IF ALL STATES and SOME POSITIONS
      if ( record.club.includes(this.state.selectedPos['value']) ) {
        // console.log('IF ALL STATES and SOME POSITIONS');
        return record
      }
      // IF SOME STATES and ALL POSITIONS
      /*
      else if ( this.state.selectedStates.indexOf(record.state) > -1 && this.state.selectedPos['value'] == 'All') {
        // console.log('IF SOME STATES and ALL POSITIONS', record.state, this.state.selectedStates );
        return record
      } 
      // IF SOME STATES and SOME POSITIONS
      else if ( this.state.selectedStates.indexOf(record.state) > -1 && record.position.includes(this.state.selectedPos['value']) ) {
        // console.log('IF SOME STATES and SOME POSITIONS');
        return record
      }*/
      
    })

    // console.log(' filteredList',  filteredList)
    // const dataSorting = this.sortByKey(filteredList, this.state.selectedSort, this.state.selectedSortDirection)

    this.setState({
      // filteredData: dataSorting
      filteredData: filteredList
    })

  }

  /* LOAD READER RANKING */
  /*sortByKey (array, key, ascdesc) {
    return array.sort((a, b) => {
      let x = (ascdesc === 'asc') ? b[key] : a[key]
      let y = (ascdesc === 'asc') ? a[key] : b[key]
      return -((x < y) ? -1 : ((x > y) ? 1 : 0))
    })
  }*/

  expandCard (e) {
        
    const targetRow = e.target.closest('.nnd-player')
    const targetSection = targetRow.querySelector('.nnd-player-content')
    const targetSectionHeight = targetSection.offsetHeight
    const targetImage = targetRow.querySelector('.nnd-player-tile')
    const targetImageHeight = targetImage.offsetHeight
    const existActiveRow = document.querySelector(".nnd-player.nnd-active")

    if ( targetRow === this.state.activeCard ) {
      targetRow.classList.toggle(`nnd-active`)
      this.setState({
        activeCard: null
      }, function () {
        targetRow.style.height = targetImageHeight + 'px'
      });

    } else {
      if (existActiveRow) {
        const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-player-tile').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        existActiveRow.style.height = existActiveRowImageHeight + 'px'
      }

      this.setState({
        activeCard: targetRow
      }, function () {
        const currentCard =  this.state.activeCard
        currentCard.classList.toggle(`nnd-active`)
        currentCard.style.height = targetImageHeight + 'px'
        targetRow.style.height = ( targetSectionHeight + targetImageHeight )+ 'px'
      });

    }
  }

  render() {
    // const isBreached = this.state.breach
    const playerTiles = (typeof this.state.filteredData !== 'undefined') ? this.state.filteredData.map((item) => {
      // console.log('item', item)
      if (typeof this.state.data !== 'undefined') {
        return (
          <div key={item.pick} className={`nnd-player`} onClick={(e) => { this.expandCard(e); e.preventDefault() }} >
            <div className='nnd-player-tile'>
              {/*<img alt={item.player} src={require(`../assets/images/${item.image}.jpg`)} />*/}
              
              <div className="nnd-cta">
                <h4 className="nnd-cta-player">
                  <div className="nnd-cta-pos">
                    { item.pick
                      ?
                      <span className="nnd-cta-pos-pick">{ item.pick}</span>
                      :
                      ""
                    }
                  </div>
                  <div className="nnd-cta-club">
                    {item.icon
                      ?
                      <img className="nnd-cta-club-icon" src={require(`../assets/images/${item.icon}.svg`)} />
                      :
                      ""
                    }
                  </div>
                  
                  <div className="nnd-cta-name">{ item.name }</div>
                  
                </h4>
                <div className="nnd-cta-icon" data-index={item.pick}>
                  <div className="nnd-cta-icon_plus"></div>
                  <div className="nnd-cta-icon_plus_vertical"></div>
                </div>
              </div>
            </div>
            <div className='nnd-player-tile-expanded'>
              <div className="nnd-player-content">
                <div className="nnd-player-content-inner">
                  
                  {/*<div className="nnd-player-text" >
                    <h3>{ item.player }</h3>
                    <h5>{ item.position }</h5>
                    <div className="nnd-details">
                      <p className="nopad"><span>Profile:</span> { item.profile }</p>
                    </div>
        </div>*/}
                  <div className="nnd-player-text-profile">
                    <div className="nnd-profile" dangerouslySetInnerHTML={{__html: item.profile}}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    }) : ''

    // const isMobApp = this.state.isMobApp
    const siteDomain = this.state.siteDomain
    const isActiveCard = this.state.activeCard

    return (
      <div id="nnd-container" className={`${siteDomain ? siteDomain : ""}`}>
        {/*<div className="nnd-header">
          <img src={require('../assets/images/header.jpg')} />
    </div>*/}

        <div className="nnd-navigation">
          <h3>AFL 2023 Draft Tracker</h3>
          {/*<p>Exclusive stats for the best juniors across the Coates Talent</p>*/}
          <Select 
            onChange={event => this.changePos(event)} 
            className="nnd-pos" 
            classNamePrefix="nnd-select" 
            options={this.state.posOptions} 
            defaultValue={this.state.selectedPos}
            // menuIsOpen={true}
          />
        </div>
        
        <div className="nnd-cont-main-wrap">
          <div className="nnd-cont-main" ref="scroller">
            <div className={isActiveCard !== null ? 'nnd-tiles nnd-activeCard' : 'nnd-tiles'} >
              {playerTiles}
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js